import { render, staticRenderFns } from "./message_queue_dialog.vue?vue&type=template&id=095a929a"
import script from "./message_queue_dialog.vue?vue&type=script&lang=ts"
export * from "./message_queue_dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports